window.onload = function () {
  // Function to check and show/hide the review button and form
  var sectionContainer = document.getElementById("testimonial-section-div");

  var loader = document.createElement("div");
  loader.className = "loader"; // You can style this class in your CSS for the loader appearance
  loader.className = "row justify-content-center add-margin";
  loader.innerHTML =
    '<i class="fa fa-circle-o-notch fa-spin fa-fw" style="font-size: 40px;color: #513030;"></i>';

  sectionContainer.appendChild(loader);

  function checkAndToggleReviewsload() {
    var checktestimonialapp = document.querySelector(
      ".stamped-reviews-wrapper"
    );

    if (checktestimonialapp) {
      loader.style.display = "none";
    }
  }

  // Check initially
  checkAndToggleReviewsload();

  // Use MutationObserver to watch for changes in the DOM
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // Check again whenever the DOM changes
      checkAndToggleReviewsload();
    });
  });

  // Configure and start the observer
  var observerConfig = {
    childList: true, // Watch for changes in the child elements
    subtree: true, // Watch for changes in the whole subtree
  };

  observer.observe(document.body, observerConfig);
};
